import { render } from "./BaiYin.vue?vue&type=template&id=36f9828b"
import script from "./BaiYin.vue?vue&type=script&lang=js"
export * from "./BaiYin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__